module.exports = __webpack_public_path__ + "img/1435694826.21c66771.jpg";